export const CONSONANT_VOWEL_PAIRS_CH_J = [

    // ㄴ
    {
        id: 1,
        korean: "자",
        english: "cha",

    },
    {
        id: 2,
        korean: "제",
        english: "che",

    },
    {
        id: 3,
        korean: "지",
        english: "chi",

    },
    {
        id: 4,
        korean: "조",
        english: "cho",

    },
    {
        id: 5,
        korean: "즈",
        english: "cheu",

    },
    {
        id: 6,
        korean: "저",
        english: "cheo",

    },
    {
        id: 7,
        korean: "쟈",
        english: "chya",

    },
    {
        id: 8,
        korean: "재",
        english: "chae",

    },
    {
        id: 9,
        korean: "졔",
        english: "chye",

    },
    {
        id: 10,
        korean: "죠",
        english: "chyo",

    },
    {
        id: 11,
        korean: "져",
        english: "chyeo",

    },
    {
        id: 12,
        korean: "쥬",
        english: "chyu",

        

    },

    {
        id: 13,
        korean: "잔",
        english: "chan", 

    },
    {
        id: 14,
        korean: "작",
        english: "chak",

        

    },
    {
        id: 15,
        korean: "짐",
        english: "chim",
        

    },
    {
        id: 16,
        korean: "잣",
        english: "chat",
        

    },
    {
        id: 17,
        korean: "잫",
        english: "chah",
        

    },
    {
        id: 18,
        korean: "접",
        english: "cheob",
        

    },
          {
        id: 19,
        korean: "즐",
        english: "cheul",
        

    },
    {
        id: 20,
        korean: "잦",
        english: "chat",
        

    },
    {
        id: 21,
        korean: "잮",
        english: "chaekk",
        

    },
    {
        id: 22,
        korean: "잰",
        english: "chaen",
        

    },
    {
        id: 23,
        korean: "쥐",
        english: "chui",
        

    },
    {
        id: 24,
        korean: "줌",
        english: "chum",
        

    },

    {
        id: 25,
        korean: "쟡",
        english: "chyat",
        

    },
    {
        id: 26,
        korean: "잧",
        english: "chat",
        

    },
    {
        id: 27,
        korean: "장",
        english: "chang",
        
    },
    {
        id: 28,
        korean: "잘",
        english: "chal",
        
    },
    {
        id: 29,
        korean: "졀",
        english: "chyeol",
        
    },
    {
        id: 30,
        korean: "젬",
        english: "chem",
        
    },
    {
        id: 31,
        korean: "젛",
        english: "cheoh",
        
    },
    {
        id: 32,
        korean: "즐",
        english: "cheul",
        
    },
    {
        id: 33,
        korean: "줘",
        english: "chwo",
        
    },
    {
        id: 34,
        korean: "즆",
        english: "chyup",
        
    },
    {
        id: 35,
        korean: "잘",
        english: "chal",
        
    },
        
    {
        id: 36,
        korean: "자주",
        english: "cha-ju",
        
    },    
    {
        id: 37,
        korean: "털즈",
        english: "teo-jeu",
        
    },    
    {
        id: 38,
        korean: "래조",
        english: "rae-jo",
        
    },    
    {
        id: 39,
        korean: "아짐",
        english: "a-jim",
        
    },
    {
        id: 40,
        korean: "잦잦",
        english: "chaj-jat",
        
    },
    
];

